import React, { useState } from "react";
import Sidebar from "../layouts/sidebar";
import Headers from "../layouts/header";
import { Link, NavLink } from "react-router-dom";
import Select from "react-select";
import Datetime from "react-datetime";
import moment from "moment";
import "react-datetime/css/react-datetime.css";
import { Nav, Tab, Row, Col, Modal } from "react-bootstrap";
import { styled } from "@mui/material/styles";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { useSelector } from "react-redux";
import Exportcsv from "./loginpages/Managementpages/Exportcsv";
import { useEffect } from "react";
import useAxiosFile from "../actions/useaxios";
import { DateTimeForm, EncryptData, isEmpty } from "../actions/common";
import { toast } from "react-toastify";
import { socket } from "../services/socket";
import { getUserId } from '../services/commonFuntion';
import QrReader from 'react-qr-reader';
import { IoMdCloseCircle } from "react-icons/io";
import config from "../actions/config"
export default function Orders() {
  const [opacity, setOpacity] = useState("false");
  const [imagesshow, setimagesshow] = useState(false);
  const { toggle, payload } = useSelector((state) => state.admin_panel.User);
  const [orderdata, setOrderData] = useState([]);

  const [PackNumber, setPackNumber] = useState([]);

  const axiosFile = useAxiosFile();

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) { },
    onSizePerPageChange: function (page, sizePerPage) { },
  });

  const [TabName, SetTabName] = useState("neworder");
  const [Tabdatas, SetTabDatas] = useState({
    neworder: { page: 1, loader: true, data: [] },
  });
  const [shoplist, SetShopList] = useState([]);
  const [currentShop, SetCurrentShop] = useState({ label: "", value: "" });
  const [showModal, SetShowModal] = useState(false)
  const [SelectedOrder, SetSelectedOrder] = useState({});
  const [SelectedDriver, SetSelectedDriver] = useState({});
  const [Drivers, SetDrivers] = useState([]);
  const [Disabled, SetDisabled] = useState(false);
  const [cameramodel, Setcameramodel] = useState(false);
  const [position, setposition] = useState(false);
  const [number, setnumber] = useState('');
  const [confirmmodel, setconfirmmodel] = useState(false);
  const [alertmodel, setalertmodel] = useState(false);
  const [submit, setsubmit] = useState(false);
  const [images, setimages] = useState([]);
  const [validateError,setValidateError] = useState({});




  const handleClose = () => {
    SetShowModal(false);
    SetSelectedDriver({})

  }
  const handlecameraClose = () => {
    Setcameramodel(false);
  }
  const HandleShowModal = (data) => {
    SetShowModal(true);
    SetSelectedOrder(data);
    // SetSelectedDriver(data?.Driver);
  }
  const handlecameraShowModal = (data) => {
    // setPackNumber([])

    Setcameramodel(true);

  }
  const handlecomfirmClose = () => {
    setValidateError({})
    setconfirmmodel(false);
  }
  const handlealertClose = () => {
    setValidateError({})
    setalertmodel(false);
  }
  const handleshowClose = () => {
    setValidateError({})
    setimagesshow(false);
  }


  useEffect(() => {

    GetDrivers();
  }, [showModal]);

  const GetDrivers = async () => {
    let Resp = await axiosFile.GetDriver({ status: true });
    if (Resp?.data?.length > 0) {
      SetDrivers(Resp.data);
    }
  };

  const ChooseDriver = async () => {
    if (SelectedDriver?._id) {
      let Resp = await axiosFile.AssignDriver({
        Order: SelectedOrder?._id,
        Driver: SelectedDriver?._id,
      });
      if (!isEmpty(Resp?.data)) {
        toast.success("Driver Assigned");
        GetOrderList();
        setTimeout(() => {
          handleClose();
        }, [2000])
      }
      else {
        toast.error("Error Occured");
      }
    } else {
      toast.error("Choose Driver");
    }
  };

  const handleError = (data) => {
    console.log(
      "handleErrorhandleError", data
    );
  }
  const Submit = (data, type, from) => {
    setsubmit(true)
    console.log('testttttt',data,PackNumber)
    if (from != 'manual') {
      if (PackNumber?.length > 0) {
        setValidateError({})
        OrderAction(data, type)

      }
      else {
        toast.error("Enter the package numbers")
        setValidateError({packageNumber:"Enter the package numbers"})

        // HandleShowModal()
        setsubmit(false)
      }
      
    }
    else {
      OrderAction(data, type)
      // setsubmit(false)

    }
  }
  const handleScan = (e) => {
    if (!isEmpty(e) && !PackNumber.includes(e)) {
      if (Array.isArray(e)) {
        setPackNumber([...PackNumber, ...e.replace(/\s+/g, '')])
      }
      else {
        setPackNumber([...PackNumber, ...Array(e.replace(/\s+/g, ''))])

      }
    }

  };
  const Switchcamera = () => {
    setposition(!position);
    Setcameramodel(false)
    setTimeout(() => {
      Setcameramodel(true)

    }, 200);
  }
  const handleChange = (e) => {

    if (e?.length > 20) {
      return toast.error("Only 20 charcters are allowed...!")
    }

    if (!isEmpty(e) && !PackNumber.includes(e)) {
      if (Array.isArray(e)) {
        setPackNumber([...PackNumber, ...e.replace(/\s+/g, '')])
      }
      else {
        setPackNumber([...PackNumber, ...Array(e.replace(/\s+/g, ''))])

      }
    }
    setnumber('')

  };
  const Cancelpackage = (index) => {
    setPackNumber([
      ...PackNumber.slice(0, index),
      ...PackNumber.slice(index + 1, PackNumber?.length),


    ])

  }

  const columns = [
    { dataField: "OrderNumber", text: "Order Id" },
    // {dataField:"vendorName",text:"Vendor Name",sort:true},
    {
      dataField: "UserId",
      text: "Customer Name",
      sort: true,
      formatter: (cell, val) => (
        <div>
          {cell?.FirstName
            ? cell?.FirstName + " " + cell?.LastName
            : cell?.EmailId}
        </div>
      ),
    },
    // {dataField:"Quantity",text:"Items",sort:true},
    { dataField: "OrderType", text: "Type", sort: true },
    // {dataField:"operationtime",text:"Operation Time",sort:true},

    // {
    //   dataField: "TransactionHistory",
    //   text: "Payment",
    //   sort: true,
    //   formatter: (cell, row) => (
    //     <div>
    //       {cell?.object?.payment_method_types?.[0]
    //         ? cell?.object?.payment_method_types?.[0]
    //         : "card"}
    //     </div>
    //   ),
    // },
    {
      dataField: "DeliveryTime",
      text: "Delivery Time",
      sort: true,
      formatter: (cell, row) => (
        <div>{DateTimeForm(cell, null, null, true)}</div>
      ),
    },
    // {
    //   dataField: "Price.Payable",
    //   text: "Amount",
    //   sort: true,
    //   formatter: (cell, val) => (
    //     <>
    //       <p>
    //         {val?.ShopId?.CurrencySymbol} {val?.Price?.PayAmount ? NumberChange(val?.Price?.PayAmount)?.toFixed(2) : '0'}
    //       </p>
    //     </>
    //   ),
    // },
    {
      dataField: "val",
      text: "Driver Select",
      sort: true,
      formatter: (cell, val) => (
        <>
          {
            val?.OrderType == "Delivery" ?
              (
                val?.Time?.ApprovedBySeller
                  ?
                  (
                    val?.Driver ?
                      <>
                        <button
                          className="blue_btn add_deliveryprsn dp_btn_hover"
                          onClick={() => HandleShowModal(val)}
                          type="button"
                        >
                          {/* <p onClick={()=>{HandleShowModal(val);}}> */}
                          View Driver
                          {/* </p> */}
                        </button>
                      </>
                      :
                      <>
                        <button
                          className="blue_btn add_deliveryprsn dp_btn_hover"
                          onClick={() => HandleShowModal(val)}
                          type="button"
                        >
                          Select Driver
                        </button>
                      </>
                  )
                  :
                  <p>Waiting for Shop Approve</p>
              )

              :
              <p>Choosed For Pickup</p>
          }

        </>
      ),
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, val) => (
        <div class="dropdown table_viewdropdown">
          <button
            class="btn table_viewdrop dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="fa-solid fa-ellipsis" />
          </button>
          <ul class="dropdown-menu men_indi_tab">
            <li>
              <Link
                class="dropdown-item"
                to={`/ordersview?id=${EncryptData(val?._id)}`}
              >
                View
              </Link>
            </li>
            {isEmpty(val?.Time?.ApprovedBySeller) &&
              isEmpty(val?.Time?.cancelbyseller) &&
              isEmpty(val?.Time?.returned) && (
                <>
                  <li>
                    <hr class="dropdown-divider" />
                  </li>
                  <li onClick={() => OrderAction(val, "approvebyseller")}>
                    <Link class="dropdown-item" to="">
                      Accept
                    </Link>
                  </li>
                </>
              )}
            {!isEmpty(val?.Time?.ApprovedBySeller) &&
              isEmpty(val?.Time?.cancelbyseller) &&
              isEmpty(val?.Time?.Dispatch) &&
              isEmpty(val?.Time?.preparing) &&
              isEmpty(val?.Time?.returned) && (
                <>
                  <li>
                    <hr class="dropdown-divider" />
                  </li>
                  <li onClick={() => OrderAction(val, "preparing")}>
                    <Link class="dropdown-item" to="">
                      Preparing
                    </Link>
                  </li>
                </>
              )}
            {!isEmpty(val?.Time?.ApprovedBySeller) &&
              isEmpty(val?.Time?.Dispatch) &&
              isEmpty(val?.Time?.cancelbyseller) &&
              isEmpty(val?.Time?.returned) && (
                <>
                  <li>
                    <hr class="dropdown-divider" />
                  </li>
                  {val?.OrderType == 'Pickup' ?
                    <li onClick={() => OrderAction(val, "dispatch")}>
                      <Link class="dropdown-item" to="">
                        Order Is Ready
                      </Link>
                    </li>
                    :
                    <li onClick={() => { setconfirmmodel(true); setOrderData(val) }}>
                      <Link class="dropdown-item" to="">
                        Order Is Ready
                      </Link>
                    </li>
                  }
                </>
              )}
            {val.Status == "dispatch" && (
              <li onClick={() => OrderAction(val, "picked")}>
                <Link class="dropdown-item" to="">
                  {val?.OrderType == 'Pickup' ? "Picked up" : "Picked up for delivery"}
                </Link>
              </li>
            )}
            {val.Status == "shipping" && (
              <li onClick={() => OrderAction(val, "delivered")}>
                <Link class="dropdown-item" to="">
                  Delivered
                </Link>
              </li>
            )}
            {val.Status == "shipping" && (
              <li onClick={() => OrderAction(val, "returned")}>
                <Link class="dropdown-item" to="">
                  Returned
                </Link>
              </li>
            )}
            {isEmpty(val?.Time?.Dispatch) &&
              isEmpty(val?.Time?.cancelbyseller) &&
              isEmpty(val?.Time?.returned) && (
                <>
                  <li>
                    <hr class="dropdown-divider" />
                  </li>
                  <li onClick={() => OrderAction(val, "cancelbyseller")}>
                    <Link class="dropdown-item" to="">
                      <p className="drpdw_redtxt">Cancel Order</p>
                    </Link>
                  </li>
                </>
              )}
          </ul>
        </div>
      ),
    },
    {
      dataField: "val",
      text: "View images",
      sort: true,
      formatter: (cell, val) => (
        <>
          {

            <>
              <button
                className="blue_btn add_deliveryprsn dp_btn_hover"
                onClick={() => { setimagesshow(true); setimages(val?.Attachments) }}
                type="button"
              >
                {/* <p onClick={()=>{HandleShowModal(val);}}> */}
                View images
                {/* </p> */}
              </button>
            </>


          }

        </>
      ),
    },
  ];

  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const stylesgraybg = {
    option: (styles, { isFocused, isSelected, isHovered }) => ({
      ...styles,
      color: "#6C6A81",
      background: isFocused
        ? "#F5F6F7"
        : isSelected
          ? "#F5F6F7"
          : isHovered
            ? "red"
            : "#F5F6F7",

      zIndex: 1,
      cursor: "pointer",
      fontSize: "13px",
    }),

    option: (styles, { isFocused, isSelected, isHovered }) => {
      // const color = chroma(data.color);

      return {
        ...styles,
        backgroundColor: isHovered
          ? "#a71d24"
          : isSelected
            ? "#a71d24"
            : isFocused
              ? "#a71d24"
              : "",
        cursor: "pointer",
        color: isHovered
          ? "#fff"
          : isSelected
            ? "#fff"
            : isFocused
              ? "#fff"
              : "",
        fontSize: "13px",
      };
    },
    valueContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      padding: "0 20px",
      backgroundColor: "#fff ",
      border: "1px solid rgba(34, 34, 34, 0.32)",
      borderRadius: 10,
      fontSize: "13px",
    }),
    control: (provided, state) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "#fff",
      border: "none",
      outline: "none",
      boxShadow: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "#6C6A81",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#6C6A81",
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
    }),
  };

  useEffect(() => {
    socket.on(getUserId(), data => {
      console.log("emit done", data)
      if (data.type && data.type === 'order') {
        GetOrderList(1, TabName);
      }
    })
  }, [socket])

  useEffect(() => {
    Tabdatas[TabName] = { page: 1, data: [], loader: false };
    SetTabDatas(Tabdatas);
    GetOrderList(1, TabName);
  }, [TabName]);

  useEffect(() => {
    if (currentShop?.value) {
      GetOrderList();
    }
  }, [currentShop?.value]);

  useEffect(() => {
    if (payload?._id) {
      GetShoplist();
    }
  }, [payload?._id]);

  const GetOrderList = async (page, tab) => {
    let senddata = {
      page: (page ? page : Tabdatas[TabName]?.page) ?? 1,
      TabName: tab ? tab : TabName,
      limit: 500,
    };
    let Resp = await axiosFile.GetOrders(senddata);
    if (Resp?.data?.length > 0) {
      // Resp?.data?.map((val) => {
      //   val.action = (
      //     <div class="dropdown table_viewdropdown">
      //       <button
      //         class="btn table_viewdrop dropdown-toggle"
      //         type="button"
      //         data-bs-toggle="dropdown"
      //         aria-expanded="false"
      //       >
      //         <i class="fa-solid fa-ellipsis" />
      //       </button>
      //       <ul class="dropdown-menu">
      //         {/* <li><Link class="dropdown-item" to={`/orderdetail?id=${EncryptData(val?._id)}`}>View</Link></li> */}
      //         {/* <li>
      //           <hr class="dropdown-divider" />
      //         </li> */}
      //         {val.Status == "dispatch" && (
      //           <li onClick={() => OrderAction(val, "shipping")}>
      //             <Link class="dropdown-item" to="">
      //               Picked up for delivery
      //             </Link>
      //           </li>
      //         )}
      //         {val.Status == "shipping" && (
      //           <li onClick={() => OrderAction(val, "delivered")}>
      //             <Link class="dropdown-item" to="">
      //               Delivered
      //             </Link>
      //           </li>
      //         )}
      //         {val.Status == "shipping" && (
      //           <li onClick={() => OrderAction(val, "returned")}>
      //             <Link class="dropdown-item" to="">
      //               Returned
      //             </Link>
      //           </li>
      //         )}
      //       </ul>
      //     </div>
      //   );
      // });
    }
    if (senddata.page == 1) {
      SetTabDatas({
        ...Tabdatas,
        ...{
          [TabName]: {
            data: Resp?.data,
            page: page,
            loader: Resp?.data?.length > 0 ? true : false,
          },
        },
      });
    } else {
      SetTabDatas({
        ...Tabdatas,
        ...{
          [TabName]: {
            data: [...Tabdatas[TabName].data, ...Resp?.data],
            page: page,
            loader: Resp?.data?.length > 0 ? true : false,
          },
        },
      });
    }
  };

  const OrderAction = async (val, action) => {
    handlecameraClose()
    const id = toast.loading("Updating...")
    if (action == "picked" && isEmpty(val?.Driver) && val?.OrderType == "Delivery") {
      return toast.update(id, { render: "Delivery Partner Not Assigned", autoClose: 1000, type: 'error', isLoading: false });
    }
    let senddata = {
      OrderId: val._id,
      Status: action,
      packageNumber: PackNumber

    };
    let Resp = await axiosFile.OrderStatusUpdate(senddata);
    if (Resp?.success == "success") {
      toast.update(id, { render: "Status Updated Successfully", type: 'success', isLoading: false, autoClose: 1000 });
    }
    else {
      toast.update(id, { render: Resp.msg, type: 'error', isLoading: false, autoClose: 1000 });
    }
    GetOrderList(1, TabName);
    handlealertClose()
    handlecomfirmClose()
    setsubmit(false);
  };

  const GetShoplist = async () => {
    let Resp = await axiosFile.GetShop({ from: "admin" });
    SetShopList(Resp?.data);
    if (Resp?.data?.length > 0) {
      SetCurrentShop({
        label: Resp?.data[0]?.label,
        value: Resp?.data[0]?.value,
      });
    }
  };

  return (
    <>

      <section id="content-wrapper">
        <div class="row mx-auto">
          <div className="top_title_sec p-0">
            <div>
              <p className="page_title">Orders</p>
            </div>
            <div className="rightsec">
              {/* <Exportcsv className='cmn_exportcsv' csvData={exportdata} fileName={"drivers"}/> */}
            </div>
          </div>
        </div>
        <div className="row mt-4 mx-auto">
          <div className="sec_border">
            <div className="row mx-auto">
              {/* <div className='col-xxl-4 col-xl-4 col-lg-3 col-md-3 col-sm-12 col-12'>
          <div className='whole_searchbar white_bg'>
     <img className='search_glass' src={require('../assests/images/Search.png')}/>
    <input placeholder="Search term"/>
     </div>
          </div> */}

              {/* <div className='col-xxl-8 col-xl-8 col-lg-9 col-md-9 col-sm-12 col-12'>
          <div className='rightside'>

<div className='rightside_select'>
          <Select
                              options={options}
                              defaultValue={selectedOption}
                              styles={stylesgraybg}
                              onChange={setSelectedOption}
                              className="border_blue_select"
                              classNamePrefix="react-select"
                              placeholder='Type'
                         
                            />
                            </div>

                            <div className='order_calendar_div'>
                              <p className={opacity == "true" ? "hiding_caltxt" : ""}>Start Date</p>
                              <img className='order_calendar_ic' src={require('../assests/images/calendar.png')}/>
                              <Datetime onChange={()=>{setOpacity("true")}} className='order_datepick'/>
                            </div>

                            <p className='order_totxt'>To</p>
                            <div className='order_calendar_div'>
                              <p className={opacityEnd == "true" ? "hiding_calendtxt" : ""}>End Date</p>
                              <img className='order_calendar_ic' src={require('../assests/images/calendar.png')}/>
                              <Datetime onChange={()=>{setEndOpacity("true")}} className='order_datepick'/>
                            </div>
                            
   
       
    
          </div>

         
          </div> */}

              <div className="orders_tabs">
                <Tab.Container
                  id="left-tabs-example"
                  defaultActiveKey={TabName}
                >
                  <Row>
                    <Col sm={12}>
                      <Nav
                        variant="pills"
                        className="flex orders_tabs"
                      >
                        <Nav.Item>
                          <Nav.Link
                            className="order_orangetab"
                            eventKey="neworder"
                            onClick={() => SetTabName("neworder")}
                          >
                            New orders
                            {/* <span className='orders_tabpop orange_tabbg'>5</span> */}
                          </Nav.Link>
                        </Nav.Item>
                        {/* <Nav.Item>
              <Nav.Link className='order_violettab' eventKey="second">Scheduled <span className='orders_tabpop violet_tabbg'>5</span></Nav.Link>
            </Nav.Item> */}
                        {/* <Nav.Item>
              <Nav.Link className='order_bluetab' eventKey="third">Accepted <span className='orders_tabpop blue_tabbg'>5</span></Nav.Link>
            </Nav.Item> */}
                        <Nav.Item>
                          <Nav.Link
                            className="order_blurbluetab"
                            eventKey="dispatch"
                            onClick={() => SetTabName("dispatch")}
                          >
                            Order is ready
                            {/* <span className='orders_tabpop blurblue_tabbg'>5</span>  */}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            className="order_lightorangetab"
                            eventKey="shipping"
                            onClick={() => SetTabName("shipping")}
                          >
                            In transist
                            {/* <span className='orders_tabpop lightorange_tabbg'>5</span> */}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            className="order_greentab"
                            eventKey="completed"
                            onClick={() => SetTabName("completed")}
                          >
                            Completed
                            {/* <span className='orders_tabpop green_tabbg'>5</span> */}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            className="order_redtab"
                            eventKey="cancelled"
                            onClick={() => SetTabName("cancelled")}
                          >
                            Cancel
                            {/* <span className='orders_tabpop red_tabbg'>5</span> */}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            className="order_skybluetab"
                            eventKey="returned"
                            onClick={() => SetTabName("returned")}
                          >
                            Returned
                            {/* <span className='orders_tabpop skyblue_tabbg'>5</span> */}
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>

                    <Col sm={12} className="border-0">
                      <Tab.Content>
                        {Tabdatas?.[TabName]?.data?.length > 0 ? (
                          <Tab.Pane eventKey={TabName}>
                            <div className="ffd_table row table_min_wid mar_bot">
                              <BootstrapTable
                                bootstrap4
                                keyField="id"
                                columns={columns}
                                data={Tabdatas[TabName]?.data}
                                pagination={pagination}
                              />
                            </div>
                          </Tab.Pane>
                        )
                          :
                          <div className="d-flex align-items-center justify-content-center">
                            <div className="d-flex flex-column align-items-center pt-4 pb-3">
                              No Order found
                            </div>
                          </div>
                        }
                        {/* <Tab.Pane eventKey="second">
            <div className='ffd_table'>
          <BootstrapTable bootstrap4 keyField='id' columns={schedulecolumns} data={data} pagination={pagination}/>
          </div>
            </Tab.Pane>
            <Tab.Pane eventKey="third">
            <div className='ffd_table'>
          <BootstrapTable bootstrap4 keyField='id' columns={schedulecolumns} data={data} pagination={pagination}/>
          </div> 
            </Tab.Pane>

            <Tab.Pane eventKey="fourth">
            <div className='ffd_table'>
          <BootstrapTable bootstrap4 keyField='id' columns={orderreadyecolumns} data={orderreadydata} pagination={pagination}/>
          </div> 
            </Tab.Pane>
            <Tab.Pane eventKey="fifth">
            <div className='ffd_table'>
          <BootstrapTable bootstrap4 keyField='id' columns={orderreadyecolumns} data={orderreadydata} pagination={pagination}/>
          </div> 
            </Tab.Pane>
            <Tab.Pane eventKey="sixth">
            <div className='ffd_table'>
          <BootstrapTable bootstrap4 keyField='id' columns={orderreadyecolumns} data={orderreadydata} pagination={pagination}/>
          </div> 
            </Tab.Pane>
            <Tab.Pane eventKey="seventh">
            <div className='ffd_table'>
          <BootstrapTable bootstrap4 keyField='id' columns={columns} data={data} pagination={pagination}/>
          </div>
            </Tab.Pane>
            <Tab.Pane eventKey="eight">
            <div className='ffd_table'>
          <BootstrapTable bootstrap4 keyField='id' columns={abandonecolumns} data={abandondata} pagination={pagination}/>
          </div>
            </Tab.Pane> */}
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </div>
            </div>
            {/* <div className='row top_filter_sec'>

          <div className='whole_searchbar'>
     <img className='search_glass' src={require('../assests/images/Search.png')}/>
    <input placeholder="Search term"/>
     </div>
          <div className='rightside'>
          <Select
        defaultValue={selectedOption}
        onChange={setSelectedOption}
        options={options}
        classNamePrefix="react-select"
      />
       <LocalizationProvider dateAdapter={AdapterDayjs} classNamePrefix="date_picker">
      <DemoContainer components={['DatePicker']}>
        <DatePicker label="start date" />
      </DemoContainer>
    </LocalizationProvider>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
        <DatePicker label="End date" />
      </DemoContainer>
    </LocalizationProvider>
          </div>
        </div> */}
          </div>
        </div>
      </section>


      <Modal
        show={showModal}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        className="reg_gender_modal"
      >
        <Modal.Header closeButton>
          {/* <Modal.Title>Modal title</Modal.Title> */}
          {
            (SelectedOrder?.Time?.Pickup ||
              SelectedOrder?.Status == "completed" ||
              !SelectedOrder?.Time?.ApprovedBySeller ||
              SelectedOrder?.Time?.cancelbyseller ||
              SelectedOrder?.Time?.cancelbyuser
            )
              ?
              "Searched Driver"
              :
              "Search Driver"
          }
        </Modal.Header>
        <Modal.Body>
          <div className="rv_rowborder mt-3">
            {
              (SelectedOrder?.Time?.Pickup ||
                SelectedOrder?.Status == "completed" ||
                !SelectedOrder?.Time?.ApprovedBySeller ||
                SelectedOrder?.Time?.cancelbyseller ||
                SelectedOrder?.Time?.cancelbyuser
              )
                ?
                <></>
                :
                <div className="mt-3">
                  <Select
                    value={isEmpty(SelectedDriver) ? { label: "Search Driver", value: "Search Driver" } : SelectedDriver}
                    options={Drivers}
                    styles={stylesgraybg}
                    onChange={(e) => SetSelectedDriver(e)}
                    isDisabled={
                      (SelectedOrder?.Time?.Pickup ||
                        SelectedOrder?.Status == "completed" ||
                        !SelectedOrder?.Time?.ApprovedBySeller ||
                        SelectedOrder?.Time?.cancelbyseller ||
                        SelectedOrder?.Time?.cancelbyuser
                      )
                        ? true
                        : false
                    }
                  />
                </div>
            }
            <div className="ov_paymentdtls payment_width">
              <div>
                <p className="ov_address wht_spc_nowrap">
                  Driver Name
                </p>
                <p className="ov_address mt-2 wht_spc_nowrap">
                  Email-Id
                </p>
                <p className="ov_address mt-2 wht_spc_nowrap">
                  Mobile
                </p>
              </div>
              <div>
                <p className="value_datetime no_wrap_tx_rig">
                  : {SelectedDriver?.FirstName}{" "}
                  {SelectedDriver?.LastName}
                </p>
                <p className="value_datetime greentxt mt-2 no_wrap_tx_rig">
                  : {SelectedDriver?.EmailId}
                </p>
                <p className="value_datetime mt-2 no_wrap_tx_rig">
                  : {SelectedDriver?.Mobile}
                </p>
              </div>
            </div>
            {!(SelectedOrder?.Time?.Pickup ||
              SelectedOrder?.Status == "completed" ||
              !SelectedOrder?.Time?.ApprovedBySeller ||
              SelectedOrder?.Time?.cancelbyseller ||
              SelectedOrder?.Time?.cancelbyuser
            ) && (
                <button
                  className="blue_btn add_deliveryprsn mt-4 dp_btn_hover"
                  onClick={() => ChooseDriver()}
                  type="button"
                >
                  Select Driver
                </button>
              )}
          </div>
        </Modal.Body>
      </Modal>

      {cameramodel &&
        <Modal
          show={cameramodel}
          onHide={handlecameraClose}
          backdrop="static"
          keyboard={false}
          centered
          className="reg_gender_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "18px" }}>
              Scan the Qr code to add the package number
            </Modal.Title>

          </Modal.Header>
          <Modal.Body>


            <QrReader
              delay={1000}
              onError={handleError}
              onScan={(e) => handleScan(e)}
              style={{ width: '100%', height: "100%" }}
              constraints={{ facingMode: position ? 'environment' : "user" }}

            />


            <div className="rv_rowborder mt-3">
              {/* {PackNumber?.map((item) =>
            <text>{item}</text>
          )
          } */}
              <div className="d-flex align-items-center gap-2 flex-wrap scantagsec ">
                {PackNumber?.map((item, index) =>
                  <p className="mb-0 labeltags">{item} <IoMdCloseCircle className="closeicons" onClick={() => Cancelpackage(index)} /></p>
                )
                }

              </div>
              <div className="text-center">
                <p>
                  Enter Manually
                </p>
                <div className="d-flex align-items-center gap-3 justify-content-center mb-3">
                  <div>
                  <input type="text" value={number} onChange={(e) => setnumber((e.target.value).trim())} />
                  {
                    validateError?.packageNumber
                    ?
                    <p className="error-msg">{validateError?.packageNumber}</p>
                    :
                    <></>
                  }
                  </div>
                  {
                    <button
                      className="blue_btn add_deliveryprsn mt-0 dp_btn_hover ml-2"
                      type="button"
                      onClick={() => handleChange(number)}
                    >
                      Add
                    </button>
                  }
                </div>

              </div>

              <div className="text-center">
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0 dp_btn_hover me-3"
                    type="button"
                    disabled={submit}
                    onClick={() => Submit(orderdata, 'dispatch')}
                  >
                    Confirm
                  </button>
                }
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0  dp_btn_hover"
                    type="button"
                    onClick={() => { Switchcamera() }}
                  >
                    Switch camera
                  </button>
                }
              </div>
            </div>
          </Modal.Body>
        </Modal>
      }
      {confirmmodel &&
        <Modal
          show={confirmmodel}
          onHide={handlecomfirmClose}
          backdrop="static"
          keyboard={false}
          centered
          className="reg_gender_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "18px" }}>
              Order for Delivery
            </Modal.Title>

          </Modal.Header>
          <Modal.Body>

            <div className="rv_rowborder mt-3">



              <div className="text-center">
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0 dp_btn_hover me-3"
                    type="button"
                    onClick={() => { Setcameramodel(true); handlecomfirmClose() }}
                  >
                    Scan the Qr
                  </button>
                }
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0 dp_btn_hover me-3"
                    type="button"
                    onClick={() => { setalertmodel(true); handlecomfirmClose() }}
                  >
                    Dispatch
                  </button>
                }

              </div>
            </div>
          </Modal.Body>
        </Modal>
      }
      {alertmodel &&
        <Modal
          show={alertmodel}
          onHide={handlealertClose}
          backdrop="static"
          keyboard={false}
          centered
          className="reg_gender_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "18px" }}> Your item will be packed by the delivery person,Are you sure want to confirm?
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>


            <div className="rv_rowborder mt-3">



              <div className="text-center">
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0 dp_btn_hover me-3"
                    type="button"
                    disabled={submit}
                    onClick={() => !submit && Submit(orderdata, 'dispatch', 'manual')}
                  >
                    Confirm
                  </button>
                }
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0  dp_btn_hover"
                    type="button"
                    onClick={() => { handlealertClose() }}
                  >
                    Cancel
                  </button>
                }
              </div>
            </div>
          </Modal.Body>
        </Modal>
      }

      <Modal
        show={imagesshow}
        onHide={handleshowClose}
        backdrop="static"
        keyboard={false}
        centered
        className="reg_gender_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Verify Images</Modal.Title>

        </Modal.Header>
        <Modal.Body>
          <div className="d-flex gap-3 justify-content-center flex-wrap">
            {images?.length > 0 ?
              images?.map((item) =>

                <img className="img-fluid sellerviewimg verifyimg" src={`${config?.IMG_URL}/verifyimages/${item}`} />

              )
              :
              <>No Data Found</>

            }
          </div>



        </Modal.Body>
      </Modal>

    </>
  );
}
